import React from 'react';
import { useApp } from '../context/AppContext';
import '../styles/Pages.css';
import '../styles/GuestList.css';
import canamLogo from '../images/CanAm Logo.png';

const SERVER = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');
const resolvePhoto = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  return `${SERVER}${url}`;
};

const GuestListPage = () => {
  const { getAttendees } = useApp();

  // Helper function to get last name
  const getLastName = (fullName) => {
    const parts = fullName.trim().split(' ');
    return parts[parts.length - 1];
  };

  // Get all attendees (people who RSVP'd yes) and sort alphabetically by last name
  const attendingGuests = getAttendees()
    .sort((a, b) => getLastName(a.name).localeCompare(getLastName(b.name)));
  const teamCounts = {
    USA: attendingGuests.filter(g => g.team === 'USA').length,
    Canada: attendingGuests.filter(g => g.team === 'Canada').length,
    Cheerleader: attendingGuests.filter(g => g.team === 'Cheerleader').length,
  };

  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-title-row">
          <img src={canamLogo} alt="CanAm Logo" className="page-title-logo" />
          <h2>Guest List</h2>
        </div>

        <div className="guest-stats">
          <div className="stat-card">
            <div className="stat-number">{attendingGuests.length}</div>
            <div className="stat-label">Total Attending</div>
          </div>
          <div className="stat-card team-usa-stat">
            <div className="stat-number">🇺🇸 {teamCounts.USA}</div>
            <div className="stat-label">Team USA</div>
          </div>
          <div className="stat-card team-canada-stat">
            <div className="stat-number">🇨🇦 {teamCounts.Canada}</div>
            <div className="stat-label">Team Canada</div>
          </div>
          <div className="stat-card team-cheerleader-stat">
            <div className="stat-number">📣 {teamCounts.Cheerleader}</div>
            <div className="stat-label">Cheerleaders</div>
          </div>
        </div>

        <div className="guests-grid">
          {attendingGuests.map(guest => (
            <div key={guest.id} className={`guest-card guest-${(guest.team || 'unknown').toLowerCase()}`}>
              {guest.photoUrl && (
                <div className="guest-photo-container">
                  <img src={resolvePhoto(guest.photoUrl)} alt={guest.name} className="guest-photo" />
                </div>
              )}
              <div className="guest-name">{guest.name}</div>
              <div className="guest-team">{guest.team}</div>
              {guest.bringingItem && (
                <div className="guest-bringing">
                  <strong>Bringing:</strong> {guest.bringingItem}
                </div>
              )}
            </div>
          ))}
        </div>

        {attendingGuests.length === 0 && (
          <div className="no-guests">
            <p>No one has RSVP'd yet. Be the first!</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GuestListPage;
